import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FooterComponent } from './nav/footer/footer.component';

@NgModule({
    declarations: [],
    imports: [CommonModule, IonicModule, RouterModule,
FooterComponent],
    exports: [FooterComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FooterComponentsModule {}
